import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const isEnterprise = searchParams.get('enterprise') === 'true';
  const requestId = searchParams.get('request_id');
  const amount = searchParams.get('amount');

  useEffect(() => {
    if (!isEnterprise || !requestId) {
      navigate('/login');
    }
  }, [isEnterprise, requestId, navigate]);

  const handlePayment = () => {
    setLoading(true);
    setTimeout(() => {
      window.location.href = `${window.location.origin}/payment/success?enterprise=true&request_id=${requestId}`;
    }, 2000);
  };

  if (!isEnterprise || !requestId) {
    return null;
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div style={{ maxWidth: '448px', width: '100%', backgroundColor: 'white', borderRadius: '12px', padding: '32px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', margin: 0 }}>
            {t('paymentPage.title')}
          </h1>
        </div>
        
        <div style={{ marginBottom: '24px' }}>
          <div style={{ backgroundColor: '#fef3c7', border: '1px solid #f59e0b', borderRadius: '8px', padding: '16px', marginBottom: '16px' }}>
            <p style={{ margin: 0, color: '#92400e' }}>
              {t('paymentPage.approvedMessage', {
                planName: t('paymentPage.planName')
              })}
            </p>
          </div>

          <div style={{ backgroundColor: '#f9fafb', padding: '16px', borderRadius: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ color: '#6b7280' }}>{t('paymentPage.requestId')}</span>
              <span style={{ fontWeight: 'medium' }}>{requestId}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: '#6b7280' }}>{t('paymentPage.amount')}</span>
              <span style={{ fontWeight: 'medium', fontSize: '18px' }}>${amount || '1000'}</span>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button 
            onClick={handlePayment}
            disabled={loading}
            style={{ 
              width: '100%', 
              backgroundColor: loading ? '#9ca3af' : '#10b981', 
              color: 'white', 
              padding: '12px 24px', 
              borderRadius: '8px', 
              border: 'none', 
              fontSize: '16px', 
              fontWeight: '600', 
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ 
                  width: '16px', 
                  height: '16px', 
                  border: '2px solid white', 
                  borderTop: '2px solid transparent', 
                  borderRadius: '50%', 
                  animation: 'spin 1s linear infinite' 
                }}></div>
                <span>{t('paymentPage.processing')}</span>
              </div>
            ) : (
              t('paymentPage.completePayment')
            )}
          </button>
          
          <button 
            onClick={() => navigate('/login')}
            style={{ 
              width: '100%', 
              backgroundColor: 'white', 
              color: '#6b7280', 
              padding: '12px 24px', 
              borderRadius: '8px', 
              border: '1px solid #d1d5db', 
              fontSize: '16px', 
              fontWeight: '600', 
              cursor: 'pointer'
            }}
          >
            {t('common.cancel')}
          </button>
        </div>

        <p style={{ fontSize: '14px', color: '#6b7280', textAlign: 'center', marginTop: '16px' }}>
          {t('paymentPage.autoActivateNote')}
        </p>
      </div>
    </div>
  );
};

export default PaymentPage;
